module.exports = __webpack_public_path__ + "static/media/4.12ea08de.jpg";